// extracted by mini-css-extract-plugin
module.exports = {"main":"MainContent_main__1__2C"};